import { axiosInstance } from '@/lib/axios'

export interface TransferDatabaseRequest {
  sourceDatabaseId: number
  targetServerId: number
}

export interface TransferStatusResponse {
  // queued | validating | blocking | backing_up | restoring | switching | cleaning_up | completed | failed | unknown
  status: string
  progress: number
  step: string | null
  errorMessage: string | null
  databaseId: number
  sourceServerId: number
  targetServerId: number
}

export interface AdminServerModel {
  id: number
  name: string
  address: string
  isPrivate?: boolean
}

export function startDatabaseTransfer(request: TransferDatabaseRequest) {
  return axiosInstance.post<{ jobId: string; message: string }>(
    '/config-api/database/transfer',
    request,
  )
}

export function getDatabaseTransferStatus(jobId: string) {
  return axiosInstance.get<TransferStatusResponse>(
    `/config-api/database/transfer/status/${jobId}`,
  )
}

export function listServers() {
  return axiosInstance.get('/config-api/server')
}
